var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-textarea',{staticClass:"my-4",attrs:{"background-color":_vm.backgroundColor,"maxlength":_vm.maxLength,"outlined":"","counter":""},on:{"input":function($event){return _vm.onInput()}},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }